import _ from 'lodash';
import * as types from '@/store/mutation-types';
import { searchParty } from '@/mixins/search-party';

const mutations = {
  [types.ADD_NEW_TALL_CARD](state, p) {
    const drp = p.drp;
    drp.cards.splice(0, 0, p.newCard);
  },
  [types.REMOVE_TALL_CARD](state, p) {
    const drp = p.drp;
    const mq = searchParty.methods._goFind({
      entry: drp.mediaQueries,
      key: 'selector',
      value: `#drp-${p.cardId}`,
    });
    mq.parentArray.splice(mq.index, 1);
    drp.cards.splice(p.cardIndex, 1);
  },
  [types.SET_TALL_CARD_TEXT](state, p) {
    const drp = p.drp;
    drp.cards[p.cardIndex][p.type] = p[p.type];
  },
  [types.SET_TALL_CARD_HREF](state, p) {
    const drp = p.drp;
    const card = _.find(drp.cards, { _id: p.linkId });
    if (card && !_.isUndefined(p.link)) {
      card.href = p.link;
    }
  },
  [types.SET_TALL_CARD_WINDOW](state, p) {
    const drp = p.drp;
    const card = _.find(drp.cards, { _id: p.id });
    card.newWindow = p.newWindow;
    card.target = p.target;
  },
  [types.SET_TALL_CARD_ACTIVE_CARD](state, p) {
    const drp = p.drp;
    drp.activeCard = p.activeCard;
  },
};

const actions = {
  addNewTallCard: ({ commit }, payload) => {
    commit(types.ADD_NEW_TALL_CARD, payload);
  },
  removeTallCard: ({ commit }, payload) => {
    commit(types.REMOVE_TALL_CARD, payload);
  },
  async setTallCardText({ dispatch, commit }, payload) {
    payload[payload.type] = payload[payload.type];
    await commit(types.SET_TALL_CARD_TEXT, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
  setTallCardHref: ({ commit }, payload) => {
    commit(types.SET_TALL_CARD_HREF, payload);
  },
  setTallCardWindow: ({ commit }, payload) => {
    payload.target = (payload.newWindow) ? '_blank' : '_self';
    commit(types.SET_TALL_CARD_WINDOW, payload);
  },
  setTallCardActiveCard: ({ commit }, payload) => {
    commit(types.SET_TALL_CARD_ACTIVE_CARD, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-tall/vuex.js